import OstaliPartnerjiCardItem from "./OstaliPartnerjiCardItem";

const OstaliPartnerjiCards = ({ otherPartners }) => {
  return (
    <div>
      {otherPartners?.map((partner) => (
        <OstaliPartnerjiCardItem key={partner.partnerID} partner={partner} />
      ))}
    </div>
  );
};

export default OstaliPartnerjiCards;
